/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MeInformation } from '../models/MeInformation';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MeInformationService {
    /**
     * @deprecated
     * Provides user (and team) information about the executing user
     * This endpoint is equivalent to the [/me](#/Me%20Information/findMeInformation) endpoint, however it only exists due to legacy reasons.
     * @returns MeInformation Me-Information
     * @throws ApiError
     */
    public static findMeInformationDeprecated(): CancelablePromise<MeInformation> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/user',
            errors: {
                403: `Not authorized (missing API token)`,
            },
        });
    }
    /**
     * Provides user (and team) information about the executing user
     * @returns MeInformation Me-Information
     * @throws ApiError
     */
    public static findMeInformation(): CancelablePromise<MeInformation> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/me',
            errors: {
                403: `Not authorized (missing API token)`,
            },
        });
    }
}
